import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { ItemModel } from '../../models/item';
import { getItems } from '../../apis/emr-data';

interface ProcessData {
    byVisitStatusId: Dictionary<ItemModel>;
    byVisitTypeId: Dictionary<ItemModel>;
}

export interface State {
    allVisitStatusIds: number[];
    allVisitTypeIds: number[];
    byVisitStatusId: Dictionary<ItemModel>;
    byVisitTypeId: Dictionary<ItemModel>;
    loading: Dictionary<boolean>;
}

export const items = createModel<State>({
    state: {
        allVisitStatusIds: [],
        allVisitTypeIds: [],
        byVisitStatusId: {},
        byVisitTypeId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: ItemModel[],
            action?: string
        ): State => {
            const processedData = storeByItemValue(data);
            const byVisitStatusId = {
                ...state.byVisitStatusId,
                ...processedData.byVisitStatusId
            };
            const byVisitTypeId = {
                ...state.byVisitTypeId,
                ...processedData.byVisitTypeId
            };

            return {
                ...state,
                allVisitStatusIds: Object.keys(byVisitStatusId).map(x => +x),
                allVisitTypeIds: Object.keys(byVisitTypeId).map(x => +x),
                byVisitStatusId: byVisitStatusId,
                byVisitTypeId: byVisitTypeId,
                ...action && {
                    loading: {
                        ...state.loading,
                        [action]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            action: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [action]: loading
            }
        })
    },
    effects: () => ({
        async getItemsAsync(_: Undefinable<{}>, rootState: RootState) {
            if (selectors.getVisitStatusIds(rootState.items).length === 0 &&
                selectors.getVisitTypeIds(rootState.items).length === 0) {
                try {
                    const data = await getItems();
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});

export const storeByItemValue = (arr: Undefinable<ItemModel[]>): ProcessData => {
    const byVisitStatusId = {} as Dictionary<ItemModel>;
    const byVisitTypeId = {} as Dictionary<ItemModel>;
    if (arr) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].listTypeId === 1) {
                byVisitTypeId[arr[i].itemValue] = arr[i];
            } else if (arr[i].listTypeId === 2) {
                byVisitStatusId[arr[i].itemValue] = arr[i];
            }
        }
    }
    return {
        byVisitStatusId,
        byVisitTypeId
    };
};
